import React from "react";
import { useNavigate } from "react-router-dom";
import "./welcome-page.scss";


const TimeOver: React.FC = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/");
  };

  return (
    <div className="welcome-page text-center">
      <h1 >Time's up!</h1>
      <p className="mt-5">Your quiz has been automatically submitted. Thank you for participating!</p>
      <button onClick={handleButtonClick} className="submit-btn">
        Go to HomePage
      </button>
    </div>
  );
};


export default TimeOver;
